import React from 'react';
import './Spinner.css';
const Spinner = () => {
    return (
        <div className='hero min-h-screen lg:max-w-md mx-auto max-w-sm'>
            <div><span className="loader"></span></div>
        </div>
    );
};

export default Spinner;